import { defaultNodes, unitText } from './document.mjs'

// Number each type in source order, independently at paragraph and unit level.
export function nodeLabels(document, schemas = defaultNodes) {
  const types = new Map(
    schemas.flatMap((type) => [[type.id, type], ...(type.legacyId ? [[type.legacyId, type]] : [])]),
  )
  const labels = new Map()
  const sentenceOrder = new Map(
    document.paragraphs.flatMap((p) => p.sentences || []).map((s, i) => [s.id, i]),
  )
  const units = [...document.units].sort(
    (a, b) =>
      (sentenceOrder.get(a.sentenceIds?.[0]) ?? Infinity) -
      (sentenceOrder.get(b.sentenceIds?.[0]) ?? Infinity),
  )
  for (const group of [document.paragraphs.filter((p) => p.kind === 'paragraph'), units]) {
    const counts = new Map()
    for (const node of group) {
      const type = types.get(node.type),
        key = type?.id ?? node.type
      const number = (counts.get(key) || 0) + 1
      counts.set(key, number)
      labels.set(
        node.id,
        `${type?.english?.trim() || type?.name?.trim() || 'Node'}${String(number).padStart(2, '0')}`,
      )
    }
  }
  return labels
}

export function nodeWidth(label, unit = false) {
  const size = unit ? 11 : 14
  return Math.max(
    unit ? 64 : 83,
    Array.from(label).reduce(
      (width, char) => width + (char.charCodeAt(0) > 255 ? size : size * 0.6),
      unit ? 20 : 44,
    ),
  )
}

export function nodeDetail(node, document) {
  return node.paragraphId
    ? unitText(node, document)
    : node.paragraph_representation || node.argument_representation || node.display_label || ''
}
